module.exports = __webpack_public_path__ + "static/american-express-a67a7ebaecfd5b7a70b9c76eb1613398.jpg";